(() => {
 const valid = ['all','confidence','intimacy','wellbeing'];
 const labels = {all:'All books',confidence:'Dating & confidence',intimacy:'Intimacy & connection',wellbeing:'Growth & posture'};
 const controls = Array.from(document.querySelectorAll('button[data-op-genre]'));
 const cards = Array.from(document.querySelectorAll('[data-op-book-genre]'));
 if (!controls.length) return;
 function choose(genre, announce) {
  if (!valid.includes(genre)) genre='all';
  document.documentElement.dataset.opGenre=genre;
  if(announce)try{sessionStorage.setItem('op-genre',genre);}catch{}
  controls.forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.opGenre===genre)));
  cards.forEach(card=>{card.hidden=genre!=='all'&&card.dataset.opBookGenre!==genre;});
  const count=cards.filter(card=>!card.hidden).length;
  document.querySelectorAll('[data-op-genre-status]').forEach(status=>{status.textContent=announce?labels[genre]+' · '+count+' book'+(count===1?'':'s')+' shown.'+(document.querySelector('[data-book-bundle]')?' Your bundle selections are kept.':''):'';});
 }
 controls.forEach(button=>button.addEventListener('click',()=>choose(button.dataset.opGenre,true)));
 document.querySelectorAll('[data-book-tier="7"]').forEach(button=>button.addEventListener('click',()=>choose('all',true)));
 choose('all',false);
})();